import { types } from 'mobx-state-tree';

export const CheckedOrders = types
  .model({
    allOrdersChecked: false,
  })
  .actions(self => ({
    toggleCheckedOrder(code, checkboxStatus, itemEnded=false) {
      if (checkboxStatus === false) {
        self.checkedOrders.delete(code);
        if(self.setEndedCheckedListings && itemEnded) {
          self.setEndedCheckedListings(false);
        }
        self.allOrdersChecked = false;
      } else {
        self.checkedOrders.set(code, true);
        if(self.setEndedCheckedListings && itemEnded) {
          self.setEndedCheckedListings(true);
        }
        if(self.setCheckboxClicked && !self.checkboxClicked) {
          self.setCheckboxClicked(true);
          self.toggleActionBar(true);
        }
        if(self.checkedOrders.size === self.tableData.length) {
          if(self.tableData.every(({id}) => self.checkedOrders.get(id) === true)) {
            self.allOrdersChecked = true;
          }
        }
      }
    },
    toggleCheckedAllOrders(e) {
      if (e === true || (e.target && e.target.checked === true)) {
        self.tableData.forEach(({ id, status }) => {
          if (self.orderStatusIsSameAsChartFilterOrEmpty(status)) {
            if(self.setEndedCheckedListings && status==='ended') {
              self.setEndedCheckedListings(true);
            }
            self.checkedOrders.set(id, true);
          }
        });
        self.allOrdersChecked = true;
        if(self.setCheckboxClicked && !self.checkboxClicked) {
          self.setCheckboxClicked(true);
          self.toggleActionBar(true);
        }
      } else {
        if(self.resetEndedCheckedListings) {
          self.resetEndedCheckedListings();
        }
        self.checkedOrders.clear();
        self.allOrdersChecked = false;
      }
    },
    orderStatusIsSameAsChartFilterOrEmpty(status) {
      return self.chartFilter === status || self.chartFilter === '' || !self.chartFilter;
    },
  }));
